import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ExtraInfo } from '../../../../models/extra-info.model';
import { Student } from '../../../../models/student.model';
import { StudentExtraInfo } from '../../../../models/student-extrainfo.model';

@Component({
  selector: 'app-student-edit-extra-info',
  templateUrl: './student-edit-extra-info.component.html',
  styleUrls: ['./student-edit-extra-info.component.scss']
})
export class StudentEditExtraInfoComponent implements OnInit {

    @Input() student   : Student;
    @Input() extraInfos: ExtraInfo[];

    @Output() studentChange  = new EventEmitter<Student>();
    @Output() isStudentValid = new EventEmitter<boolean>();

    public yesNoOptions: any[] = [
        { label: 'No' , value: false },
        { label: 'Sí' , value: true  }
    ]

    ngOnInit (): void {

        this.initData();

    }

    private initData() {

        let studentExtraInfos = [];
        this.extraInfos.forEach(ei => {

            let extraInfoExists = this.student?.extraInfos?.find(sei => sei.extraInfoId === ei.extraInfoId);
            if (extraInfoExists) {

                studentExtraInfos.push(extraInfoExists);

            } else {

                let studentExtraInfo = new StudentExtraInfo();
                    studentExtraInfo.studentId            = this.student.studentId;
                    studentExtraInfo.extraInfoId          = ei.extraInfoId;
                    studentExtraInfo.extraInfoName        = ei.name;
                    studentExtraInfo.extraInfoDisplayName = ei.displayName;
                    studentExtraInfo.active               = false;
                    studentExtraInfo.observations         = null;

                studentExtraInfos.push(studentExtraInfo);

            }

        });

        this.student.extraInfos = structuredClone(studentExtraInfos);
        this.onStudentChange();

    }

    private isFormValid() : boolean {

        let isValidExtraInfos = [];
        this.student.extraInfos.forEach((sei: StudentExtraInfo) => {

            let isValidActive = sei.active !== null;
            isValidExtraInfos.push(isValidActive);

            let isValidObservations = (sei.active === true && sei.observations && sei.observations !== null && sei.observations !== '') || sei.active === false;
            isValidExtraInfos.push(isValidObservations);

        })

        return isValidExtraInfos.every(validation => validation === true);

    }

    public onStudentChange() {

        let isFormValid = this.isFormValid();
        this.isStudentValid.emit(isFormValid);

        if (isFormValid) { this.studentChange.emit(this.student); }

    }

}
